module.exports = __webpack_public_path__ + "media/bootstrap-icons/lightning-charge-fill-4f28bd27.svg";